import { useDispatch } from 'react-redux'
import { setDisabledRelations, setDisabledTypes } from 'Actions/explore'
import { GRAPH, RELATION, TYPE } from 'Types'
import { connect } from 'react-redux'
import './index.scss'

FilterBody = ({
  idField,
  filterValue,
  items,
  updateFilter,
  CellRenderItem,
  configNode,
  disabledTypes,
  disabledRelations,
  setDisabledRelations,
  setDisabledTypes
}) ->

  dispatch = useDispatch()

  onCheck = ({ target: { value, checked }}) ->
    dispatch(updateFilter({ [idField]: value, enabled: checked }))

  getRelevantStoreItems = (shouldEnable, item) ->
    identifier = item.key or item.id

    if item.id?
      filterType = TYPE
      data = disabledTypes
      updateStoreFn = setDisabledTypes
    else if item.key
      filterType = RELATION
      data = disabledRelations
      updateStoreFn = setDisabledRelations

    if shouldEnable is true
      data = data.filter((elem) -> elem isnt identifier)
    else
      data = [data..., identifier]

    { updateStoreFn, data }

  updateDefaultEnabledItem = (shouldEnable, filterItem) ->
    { updateStoreFn, data } = getRelevantStoreItems(shouldEnable, filterItem)
    cleanData = _.uniq(data)
    updateStoreFn(cleanData)

    configNode.update(cleanData)

  filter = (items) ->
    _.filter(items, ({ label }) ->
      label?.toLowerCase().includes(filterValue.toLowerCase())
    )

  <div style={{ whiteSpace: 'nowrap', overflow: 'auto', flex: '1 1 auto' }}>
    {
      filter(items).map((item) ->
        <CellRenderItem
          item={item}
          onChange={onCheck}
          onClick={(bool) -> updateDefaultEnabledItem(bool, item)}
          key={item.id or item.key}
        />
      )
    }
  </div>

export default connect(({ explore: { disabledRelations, disabledTypes }}) ->
    { disabledRelations, disabledTypes }
  , { setDisabledRelations, setDisabledTypes }
  )(FilterBody)
